import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import approvalImage from "../assets/img/approved.svg";
import errorImage from "../assets/img/denied.svg";
import deniedImage from "../assets/img/denied.svg";
import infoImage from "../assets/img/error_icon.svg";
import peocessingImage from "../assets/img/processing_icon.svg";
import logoFill from "../assets/img/logoFill_balck.svg";
import AccountFooter from "../components/AccountFooter";
import { withdrawalRequest } from "../services/plaid";

function Withdrawal() {
  const [searchParams] = useSearchParams();
  const txnId = searchParams.get("transaction_id");
  const [popup, setPopup] = useState(false);
  const [withdrawalResponse, setWithdrawalResponse] = useState(null);
  const [withdrawalResponseError, setWithdrawalResponseError] = useState(false);
  const [timeout, setTimeout] = useState(false);
  const counter = useRef(0);
  const [date, setDate] = useState("");
  const timeout1 = useRef();
  const interval0 = useRef();

  const weekdays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const requestWithdrawal = (txnId) => {
    setWithdrawalResponseError(false);

    withdrawalRequest(txnId)
      .then((response) => {
        // console.log(response);
        // setPopup(true);

        // response = {
        //   bank_name: "Discover",
        //   user_id: 11951,
        //   status: "WITHDRAWAL_REQUESTED",
        //   failed_reason: "Transaction cancelled.",
        //   bank_mask: "0003",
        //   amount: 2.0,
        //   action_date: "2022-09-17T07:10:14.759",
        //   success: true,
        // };

        const date = new Date(response.action_date);

        setWithdrawalResponse(response);

        if (
          response.status === "WITHDRAWAL_REQUESTED" ||
          response.status === "WITHDRAWAL_PROCESSING"
        ) {
          setPopup(true);
        }

        setDate(
          `${weekdays[date.getDay()]}, ${
            monthNames[date.getMonth()]
          } ${date.getDate()}, ${date.getFullYear()}`
        );
      })
      .catch((error) => {
        setWithdrawalResponseError(true);
        setPopup(false);
        console.log(error);
      });
  };

  useEffect(() => {
    if (withdrawalResponse) {
      interval0.current = setInterval(() => {
        counter.current += 1;

        if (counter.current > 5) {
          setPopup(false);
          setTimeout(true);
          clearInterval(interval0.current);
        } else {
          if (
            withdrawalResponse.status === "WITHDRAWAL_REQUESTED" ||
            withdrawalResponse.status === "WITHDRAWAL_PROCESSING"
          ) {
            setPopup(true);
            requestWithdrawal(txnId);
          } else {
            setPopup(false);
            clearInterval(interval0.current);
          }
        }
      }, 5000);
    }

    return () => {
      interval0.current && clearInterval(interval0.current);
    };
    // console.log(withdrawalResponse);
    // const interval0 = setInterval(() => {
    //   console.log("interval called");
    //   if (withdrawalResponse) {
    //     counter.current += 1;
    //     if (
    //       withdrawalResponse.status === "WITHDRAWAL_REQUESTED" ||
    //       withdrawalResponse.status === "WITHDRAWAL_PROCESSING"
    //     ) {
    //       setPopup(true);
    //       requestWithdrawal(txnId);
    //     } else {
    //       setPopup(false);
    //       clearInterval(interval0);
    //     }
    //   }
    //   if (counter.current > 2) {
    //     console.log(counter.current, interval0);
    //     clearInterval(interval0);
    //     setPopup(false);
    //   }
    //   console.log("count", counter.current);
    // }, 5000);
    // return () => {
    //   clearInterval(interval0);
    // };
  }, [withdrawalResponse]);

  useEffect(() => {
    requestWithdrawal(txnId);

    // timeout1.current = setTimeout(() => {
    //   console.log("lvl30", interval0.current);
    //   clearInterval(interval0.current);
    //   setPopup(false);
    // }, 10000);

    // return () => {
    //   clearInterval(interval0.current);
    //   clearTimeout(timeout1.current);
    // };
  }, [txnId]);

  return (
    <>
      <div className="tc-header container-xl">
        <div className="tc-logo">
          <div className="tc-logo-1">
            <a href="/">
              <img src={logoFill} />
              {/* <span className="logoFillSlogan">by Times of India</span> */}
            </a>
          </div>
        </div>
        <div className="tc-btns">
          <div>
            <Link to="/login">
              <button className="btnLogin1">Log In</button>
            </Link>
          </div>
          <div>
            <Link to="/signup">
              <button className="btnSignup1">Sign Up</button>
            </Link>
          </div>
        </div>
      </div>
      <section className="withdrawal" style={{ height: "calc(100vh - 157px)" }}>
        {withdrawalResponse && withdrawalResponseError === false && (
          <>
            {withdrawalResponse.status === "WITHDRAWAL_SUCCESS" && (
              <>
                <div className="withdrawal_wrapper">
                  <div className="withdrawal_img">
                    <img src={approvalImage} alt="" />
                  </div>

                  <div className="withdrawal_content">
                    <h1>Withdrawal Processed!</h1>

                    <div className="withdrawal_content_text">
                      <p>
                        Your withdrawal of{" "}
                        <strong>${withdrawalResponse.amount}</strong> to{" "}
                        <strong>
                          {withdrawalResponse.bank_name}{" "}
                          {withdrawalResponse.bank_mask}
                        </strong>{" "}
                        has been processed successfully & cash is deposited to
                        your bank account.
                      </p>
                    </div>
                  </div>
                  <a href="/">
                    <button className="withdrawal_button mobHide">
                      Go Home
                    </button>
                  </a>
                  <a href="https://tclub.onelink.me/Iiw9/wallet">
                    <button className="withdrawal_button desktopHide">
                      Open App
                    </button>
                  </a>
                </div>
              </>
            )}
            {withdrawalResponse.status === "WITHDRAWAL_FAILURE" &&
              withdrawalResponse.failed_reason === "Transaction cancelled." && (
                <>
                  <div className="withdrawal_wrapper">
                    <div className="withdrawal_img">
                      <img src={deniedImage} alt="" />
                    </div>

                    <div className="withdrawal_content">
                      <h1>Withdrawal Denied</h1>

                      <div className="withdrawal_content_text">
                        <p>
                          The recent request to withdraw{" "}
                          <strong>${withdrawalResponse.amount}</strong> to{" "}
                          <strong>
                            {withdrawalResponse.bank_name}{" "}
                            {withdrawalResponse.bank_mask}
                          </strong>{" "}
                          did not complete. The funds have not left your Times
                          Club account. The balance has not changed.
                        </p>
                      </div>
                    </div>
                    <a href="/">
                      <button className="withdrawal_button mobHide">
                        Go Home
                      </button>
                    </a>
                    <a href="https://tclub.onelink.me/Iiw9/wallet">
                      <button className="withdrawal_button desktopHide">
                        Open App
                      </button>
                    </a>
                  </div>
                </>
              )}
            {withdrawalResponse.status === "WITHDRAWAL_FAILURE" &&
              withdrawalResponse.failed_reason !== "Transaction cancelled." && (
                <>
                  <div className="withdrawal_wrapper">
                    <div className="withdrawal_img">
                      <img src={infoImage} alt="" />
                    </div>

                    <div className="withdrawal_content">
                      <h1>Oops! Something went wrong</h1>

                      <div className="withdrawal_content_text">
                        <p>
                          Looks like an error occured while trying to process
                          your request.
                        </p>
                        <p>
                          Please try the link again or raise a new withdrawal
                          request.
                        </p>
                      </div>
                    </div>
                    <a href="/">
                      <button className="withdrawal_button mobHide">
                        Go Home
                      </button>
                    </a>
                    <a href="https://tclub.onelink.me/Iiw9/wallet">
                      <button className="withdrawal_button desktopHide">
                        Open App
                      </button>
                    </a>
                  </div>
                </>
              )}
            {withdrawalResponse.status === "MANUAL_WITHDRAWAL_FAILURE" && (
              <>
                <div className="withdrawal_wrapper">
                  <div className="withdrawal_img">
                    <img src={deniedImage} alt="" />
                  </div>

                  <div className="withdrawal_content">
                    <h1>Withdrawal Denied</h1>

                    <div className="withdrawal_content_text">
                      <p>
                        The recent request to withdraw{" "}
                        <strong>${withdrawalResponse.amount}</strong> to{" "}
                        <strong>
                          {withdrawalResponse.bank_name}{" "}
                          {withdrawalResponse.bank_mask}
                        </strong>{" "}
                        did not complete. The funds have not left your Times
                        Club account. The balance has not changed.
                      </p>
                    </div>
                  </div>
                  <a href="/">
                    <button className="withdrawal_button mobHide">
                      Go Home
                    </button>
                  </a>
                  <a href="https://tclub.onelink.me/Iiw9/wallet">
                    <button className="withdrawal_button desktopHide">
                      Open App
                    </button>
                  </a>
                </div>
              </>
            )}
            {withdrawalResponse.status ===
              "WITHDRAWAL_AUTHENTICATION_FAILURE" && (
              <>
                <div className="withdrawal_wrapper">
                  <div className="withdrawal_img">
                    <img src={deniedImage} alt="" />
                  </div>

                  <div className="withdrawal_content">
                    <h1>Link Expired</h1>

                    <div className="withdrawal_content_text">
                      <p>
                        For security reasons, withdrawal links expire after 30
                        minutes.
                      </p>
                      <p>Please raise a new withdrawal request.</p>
                    </div>
                  </div>
                  <a href="/">
                    <button className="withdrawal_button mobHide">
                      Go Home
                    </button>
                  </a>
                  <a href="https://tclub.onelink.me/Iiw9/wallet">
                    <button className="withdrawal_button desktopHide">
                      Open App
                    </button>
                  </a>
                </div>
              </>
            )}
            {timeout === true && (
              <>
                <div className="withdrawal_wrapper">
                  <div className="withdrawal_img">
                    <img src={peocessingImage} alt="" />
                  </div>

                  <div className="withdrawal_content">
                    <h1>Processing Withdrawal</h1>

                    <div className="withdrawal_content_text">
                      <p>
                        Your withdrawal of{" "}
                        <strong>${withdrawalResponse.amount}</strong> to{" "}
                        <strong>
                          {withdrawalResponse.bank_name}{" "}
                          {withdrawalResponse.bank_mask}
                        </strong>{" "}
                        has been started. The cash should be in your bank by{" "}
                        {date}.
                      </p>
                    </div>
                  </div>
                  <a href="/">
                    <button className="withdrawal_button mobHide">
                      Go Home
                    </button>
                  </a>
                  <a href="https://tclub.onelink.me/Iiw9/wallet">
                    <button className="withdrawal_button desktopHide">
                      Open App
                    </button>
                  </a>
                </div>
              </>
            )}
          </>
        )}

        {withdrawalResponseError === true && (
          <div className="withdrawal_wrapper">
            <div className="withdrawal_img">
              <img src={errorImage} alt="" />
            </div>

            <div className="withdrawal_content">
              <h1>Error Occurred</h1>

              <div className="withdrawal_content_text">
                <p>Something went wrong while processing your request.</p>
                <p>
                  Please try again after sometime or raise another withdrawal
                  request after 3 hours.
                </p>
              </div>
            </div>
            <a href="/">
              <button className="withdrawal_button mobHide">Go Home</button>
            </a>
            <a href="https://tclub.onelink.me/Iiw9/wallet">
              <button className="withdrawal_button desktopHide">
                Open App
              </button>
            </a>
          </div>
        )}
      </section>
      <AccountFooter />
      {popup && (
        <div className="popUpOverlay">
          <div className="popUpInner">
            <div className="popUpBox boxBig  noBorder">
              <div className="loaderBox">
                <div className="circle-loader-wrap">
                  <div className="left-wrap">
                    <div className="loader"></div>
                  </div>
                  <div className="right-wrap">
                    <div className="loader"></div>
                  </div>
                </div>
              </div>
              <div className="popupTxt">
                <p>
                  Processing your withdrawal request.
                  <br /> This may take up to 30 seconds.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Withdrawal;
